export default "__VITE_ASSET__BLlzvG2G__"